import InstructorClass from './../InstructorClass/InstructorClass.vue'
import ProgressControl from './../ProgressControl/ProgressControl.vue'
import Advisory from './../Advisory/Advisory.vue'
export default {
    name: 'Instructor',
    components: {
        InstructorClass, ProgressControl, Advisory,
    },
    data() {
        return {
            //辅导员
            CounselorList: {},
            id: '',
            dialogFormVisible: false,
            dialogFormPwd: false,
            // 修改信息弹窗的数组
            form: {
                name: '',
                unitName: '',
                e_mailAddress: '',
                type: [],
                OldPassword: '',
                NewPassword: ''
            },
            // 修改信息弹窗的label宽度
            formLabelWidth: '100px',
        }
    },
    methods: {
        //修改密码
        changePassword() {
            if (this.checkPassword()) {
                let data = {
                    opassword: this.form.OldPassword,
                    password: this.form.NewPassword,
                    token: this.$store.state.instructor
                }
                this.$post('instructor/setpswd', data).then(res => {
                    if (res.data.status == 'success') {
                        this.$message.success('修改成功');
                        this.dialogFormPwd = false;
                    } else {
                        this.$message.error('修改失败');
                    }
                })
            }
            this.form.OldPassword = '';
            this.form.NewPassword = '';
        },
        //验证密码
        checkPassword() {
            if (this.form.OldPassword == '') {
                this.$message.error('旧密码不能为空');
                return false;
            } else if (this.form.NewPassword == '') {
                this.$message.error('新密码不能为空');
                return false;
            }
            else {
                return true;
            }
        },
        //查询辅导员
        Search() {
            this.$post('instructor/profile', { token: this.$store.state.instructor }).then(res => {
                // // console.log(res.data.result);
                this.CounselorList = res.data.result
				this.id = this.CounselorList.id
            })

        },
        // 修改更新辅导员
        changeInformation() {
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            let emsreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
            // let me = this;
            if (!this.form.name.trim()) {
                this.$message.error('名字不能为空');
            }
            else if (!this.form.unitName.trim()) {
                this.$message.error('单位名称不能为空');
            }
            else if (!this.form.e_mailAddress.trim()) {
                this.$message.error('邮箱号不能为空');
            }
            else if (!emsreg.test(this.form.e_mailAddress)) {
                this.$message.error('邮箱号格式错误');
            }
            else {
                this.$post('instructor/edit', {
                    token: this.$store.state.instructor,
                    name: this.form.name,
                    company: this.form.unitName,
                    email: this.form.e_mailAddress,
                    phone: this.CounselorList.phone,
                    desc: this.CounselorList.desc,
                    enabled: this.CounselorList.enabled,
                    id: this.CounselorList.id,
                    idcard: this.CounselorList.idcard,
                    img: this.CounselorList.img,
                    password: this.CounselorList.password,
					email:this.form.e_mailAddress
                }).then(res => {
                    if (res.data.status == 'success') {
                        this.$message({
                            showClose: true,
                            message: '编辑成功',
                            type: 'success'
                        });
                        //更新后重新请求数据刷新
                        this.Search();

                    } else {
                        // // console.log(res);
                        this.$message({
                            showClose: true,
                            message: '编辑失败',
                            type: 'error'
                        })
                    }
                    this.dialogFormVisible = false;
                    this.form = {
                        name: '',
                        unitName: '',
                        e_mailAddress: '',
                        type: [],
                        OldPassword: '',
                        NewPassword: ''
                    };
                })

            }

        },
        // 辅导员获取自己信息    
        getInformation() {
            this.$post('instructor/profile', { token: this.$store.state.instructor }).then(res => {
            })
        },

    },
    mounted() {
        //页面标题
        document.title = '辅导员后台管理系统';
        this.Search();
        this.getInformation();      
    },
}